<template>
  <a-modal :open="open" @cancel="closeForm" class="modal-no-padding edit-reference-modal">
    <div class="modal-no-padding__header">
      <h2>Удаление {{ references.length > 1 ? 'эталонных профилей' : 'эталонного профиля'}}</h2>
    </div>
    <a-divider style="margin: 16px 0" />
    <div class="modal-no-padding__body">
      Вы уверены, что хотите удалить {{ references.length > 1 ?
        'эталонные профили' :
            ('эталонный профиль ' + profileTitle? ('"' + profileTitle  + '"') : '')
      }}?
    </div>

    <template #footer>
      <a-divider style="margin: 16px 0" />
      <div class="modal-no-padding__footer">
        <div class="action-buttons">
          <a-row justify="end" :gutter="8">
            <a-col>
              <a-button class="secondary-button" @click="closeForm">Отменить</a-button>
            </a-col>
            <a-col>
              <a-button class="primary-button" :loading="modalActionLoading" @click="handleProfileDelete">Удалить</a-button>
            </a-col>
          </a-row>
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script>

import {useStore} from "vuex";
import {reactive, ref} from "@vue/runtime-core";
import {message} from "ant-design-vue";
import {computed} from "@vue/reactivity";

export default {
  props: {
    open: Boolean,
    references: Array,
  },
  emits: ['submitted', 'close'],
  setup(props, context) {
    const store = useStore();
    const modalActionLoading = ref(false);
    const profileTitle = computed(() => {
      if (props.references && props.references.length === 1) {
        return store.state.references.calculatedProfiles?.data.find((el) => el.id === props.references[0])?.title ?? '';
      }
    })

    const closeForm = () => {
      context.emit('close');
    }

    const handleProfileDelete = async () => {
       for (const reference of props.references) {
         await store.dispatch('references/deleteReferenceProfile', {id: reference});
       }

      message.success('Данные удалены');
      context.emit('submitted');
    }

    return {
      modalActionLoading,
      closeForm,
      handleProfileDelete,
      profileTitle
    }
  }
}
</script>

<style scoped lang="scss">

.edit-reference-modal {
  h2 {
    margin: 0;
    font-weight: 600;
    font-size: 16px;
    line-height: 120%;
  }

  .label {
    font-weight: 400;
    font-size: 14px;
    line-height: 120%;
    color: rgba(0, 0, 0, 0.65);
  }
}
</style>
